import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import Home from "./routes/Home";
import Detail from "./routes/Detail";
import { lightTheme, darkTheme } from "./theme";

// 🌟 전역 스타일 설정
const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${(props) => props.theme.background};
    color: ${(props) => props.theme.text};
    transition: background-color 0.3s, color 0.3s;
  }
`;

function App() {
  // ✅ localStorage에서 테마 상태 불러오기 (기본값: 라이트 모드)
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  // ✅ 테마 변경 시 localStorage에 저장
  useEffect(() => {
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  const toggleTheme = () => setIsDarkMode((prev) => !prev);

  return (
    <ThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <GlobalStyle />
      <Router basename={process.env.PUBLIC_URL}>
        <div style={{ textAlign: "center", padding: "10px" }}>
          <button
            onClick={toggleTheme}
            style={{
              background: isDarkMode ? darkTheme.button : lightTheme.button,
              color: isDarkMode ? darkTheme.buttonText : lightTheme.buttonText,
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px",
            }}>
            {isDarkMode ? "🌞 라이트 모드" : "🌙 다크 모드"}
          </button>
        </div>
        <Routes>
          <Route
            path='/'
            element={<Home />}
          />
          <Route
            path='/movie/:id'
            element={<Detail />}
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
